import React from "react";
import { object, string } from "prop-types";
import classNames from "classnames/bind";
// eslint-disable-next-line import/no-cycle
import { FluidAccordion } from "./Accordion/FluidAccordion";
// eslint-disable-next-line import/no-cycle
import { FluidTabs } from "./Tabs/FluidTabs";
import * as styles from "./TabsAndAccordionsConnector.module.scss";

const cx = classNames.bind(styles);

const TabsAndAccordionsConnector = ({ data, locale }) => {
	if (data.style === "accordion" || data.style === "FAQs")
		return (
			<FluidAccordion
				title={data.displayTitle}
				activeKey={data.activeKey}
				variant={data.variant}
				cards={data.cards}
			/>
		);
	if (data.style === "tabs")
		return (
			<FluidTabs
				variant={data.tabsVariant}
				activeKey={data.activeKey}
				cards={data.cards}
				locle={locale}
			/>
		);
	return (
		data.style === "tabs desktop / accordion mobile" && (
			<>
				<div className={cx("displayDesktop")}>
					<FluidTabs
						activeKey={data.activeKey}
						variant={data.tabsVariant}
						cards={data.cards}
						locale={locale}
					/>
				</div>
				<div className={cx("displayMobile")}>
					<FluidAccordion
						title={data.displayTitle}
						activeKey={data.activeKey}
						variant={data.variant}
						cards={data.cards}
						locale={locale}
					/>
				</div>
			</>
		)
	);
};

TabsAndAccordionsConnector.propTypes = {
	data: object.isRequired,
	locale: string,
};

TabsAndAccordionsConnector.defaultProps = {
	locale: null,
};

export default TabsAndAccordionsConnector;
export { TabsAndAccordionsConnector };
